import { Badge, notification } from 'antd';
import { Bell } from 'assets/images';
import { useNotification } from 'hooks/useNotification';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import * as selector from 'state/global/subscription/selector';
import { SUBSCRIPTION_MESSAGE_CLASS_NAME } from 'util/config/constant';

export const NotificationNavigation = () => {
  const [openNotification] = useNotification();
  const { subscriptionMessage } = useSelector((state) => ({
    subscriptionMessage: selector.selectSubscriptionMessageInfo(state)
  }));
  const { totalCount, messageObjects } = subscriptionMessage;

  const hasNotificationsInDom = () => {
    // Because the notifications will be inserted to the DOM as Portal
    // That's why we will check them by the DOM query
    // This way prevents many bugs for some cases:
    // Close by after 5s | click on notification icon | click on x button | click on tap notification
    return (
      document.getElementsByClassName(SUBSCRIPTION_MESSAGE_CLASS_NAME).length >
      0
    );
  };

  const closeNotifications = useCallback(() => {
    Object.keys(messageObjects).forEach((messageId) => {
      notification.close(messageId);
    });
  }, [messageObjects]);

  const openNotifications = useCallback(() => {
    Object.entries(messageObjects).forEach(([messageId, messageObject]) => {
      openNotification(messageId, messageObject);
    });
  }, [messageObjects, openNotification]);

  const onClickBadge = useCallback(() => {
    if (!totalCount) return;

    if (hasNotificationsInDom()) {
      closeNotifications();
    } else {
      openNotifications();
    }
  }, [closeNotifications, openNotifications, totalCount]);

  return (
    <Badge
      count={totalCount}
      showZero
      className="notification-nav no-select"
      data-testid="badge"
      onClick={onClickBadge}>
      <Bell className="notification-nav--bell-icon" />
    </Badge>
  );
};

NotificationNavigation.propTypes = {};
